import { Serializable } from '@/models/core/serializable';
import { GroupType } from '@/constants/groupType.enum';

export class GroupSetting implements Serializable<GroupSetting> {
  groupName: string;
  numberOfGroups: number;
  purposeOfTraining: number;
  groupType: number;
  notes: string;
  schoolCompetencyID: number;

  deserialize(input: any): GroupSetting {
    return this;
  }

  get groupTypeName(): string {
    return GroupType.groupTypeName(this.groupType);
  }
}

export interface GroupSetting {
  groupName: string;
  numberOfGroups: number;
  purposeOfTraining: number;
  groupType: number;
  notes: string;
  schoolCompetencyID: number;
}
